import campaignApi from 'services/api/campaign'

import { UPDATE_INVITE_BACK_IS_DISABLED } from './actionTypes'

export const updateCampaign = (subsidiaryId, categories, details) => {
  return async dispatch => {
    dispatch({
      type: 'UPDATE_CAMPAIGN_STARTED'
    })

    try {
      await campaignApi.update({ subsidiaryId, categories, details })
    } catch (err) {
      if (err) {
        dispatch({
          type: 'UPDATE_CAMPAIGN_FAILED'
        })

        return
      }
    }

    dispatch({
      type: 'UPDATED_CAMPAIGN'
    })

    dispatch(getCampaigns(subsidiaryId))
  }
}

export const getCampaigns = subsidiaryId => {
  return async dispatch => {
    dispatch({
      type: 'GET_CAMPAIGNS_STARTED'
    })

    try {
      const { items, alternateReviewLink, restrictedTextingDates, isInviteBackDisabled } =
        await campaignApi.getList(subsidiaryId)

      dispatch({
        type: 'GOT_CAMPAIGNS',
        payload: {
          items: [...items],
          alternateReviewLink,
          subsidiaryId,
          restrictedTextingDates
        }
      })

      dispatch({
        type: UPDATE_INVITE_BACK_IS_DISABLED,
        payload: { inviteBackIsDisabled: isInviteBackDisabled }
      })
    } catch (err) {
      dispatch(getCampaignsFailed(err))
    }
  }
}

export const updateCampaigns = subsidiaryId => {
  return async dispatch => {
    try {
      const { items, isInviteBackDisabled } = await campaignApi.getList(subsidiaryId)
      dispatch({
        type: 'GOT_CAMPAIGNS',
        payload: {
          items,
          subsidiaryId
        }
      })

      dispatch({
        type: UPDATE_INVITE_BACK_IS_DISABLED,
        payload: { inviteBackIsDisabled: isInviteBackDisabled }
      })
    } catch (err) {
      dispatch(getCampaignsFailed(err))
    }
  }
}

export const getCampaignsFailed = err => ({
  type: 'GET_CAMPAIGNS_FAILED',
  payload: err
})

export const initedCampaigns = () => ({
  type: 'INITED_CAMPAIGNS'
})

export const sendTestText = campaign => ({
  type: 'SENDING_TEST_TEXT',
  payload: campaign
})
